<template>
  <div>
  <HomeAltLayout bg_icon='fyiio' isHome="true">
    <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
                <a href="http://www.fyi.io">
                  <img  class="logo" src="./../../assets/fyiio-logo-with-name.svg" /> 
                </a>
          </div>
    </div>
    <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
            <h2 style="color:white;font-size:30px;" v-if="confirmed">thanks for not being a bot<br/> beep...bop...boop</h2>
            <h2 v-else style="font-size:36px;font-weight:400;color:white;">Welcome back! </h2>
            <div class="alert alert-danger" v-if="error">
              <p v-if="error" class="error">{{ error.message }}</p>
            </div>

          </div>
    </div>
            <br>   
            <form @submit.prevent="login">
              <div class="row register-form smallzer">
                  <div class="center col s10 offset-s1 m4 offset-m6 " style="background-color:white;border-radius:5px;">
                      <div class="input-field" style="height:30px">
                          <input id="username_inline" type="text"  class="fiedler form-control" v-model="username" required >
                          <label for="username_inline" class="adjust-label">Email address</label>
                      </div>
                  </div>
                </div>
                <div class="row register-form smallzer">
                  <div class="center col s10 offset-s1 m4 offset-m6 " style="background-color:white;border-radius:5px">
                      <div class="input-field" style="height:30px">
                          <input id="password_inline" type="password"  class="fiedler form-control" v-model="pass" required style="background:white">
                          <label for="password_inline" class="adjust-label">Password</label>
                      </div>
                  </div>
                </div>
                <div class="row register-form smallzer">
                  <div class="col s12 m4 offset-m6 " :class="$mq === 'md'?'left':'center'" :style="$mq === 'md'?'position:relative; left:-10px':''">
                    <button class="btn blue" style="border-radius:20px;text-transform:none">Log in</button>
                  </div>
                </div>
                <br />
                <div class="row register-form smallzer">
                  <div class="col s12 m4 offset-m6 center" >
                    <p class="forgot-password" style="color:white" >
                      Forgot your password? <router-link to="/reset_password">Click here to reset it.</router-link>
                    </p>
                    <p class="forgot-password" style="color:white" >
                      Don't have an account yet? <router-link to="/">Create one for free.</router-link>
                    </p>
                  </div>
                </div>
            </form>
  </HomeAltLayout>
  
  </div>
</template>

<script>
import HomeAltLayout from '@/containers/layouts/HomeAltLayout'
export default {
  data () {
    return {
      confirmed: this.$route.query.confirmed || false,
      username: this.$route.query.username || '',
      pass: '',
      error: null
    }
  },
  mounted(){
    $('#bigz').removeClass('blue-bg').addClass('babyblue-bg');
    //console.log("hold is:", hold)
  },
  methods: {
    login () {
      this.$cognitoAuth.signin(this.username, this.pass, (err, result) => {
        if (err) {
          this.error = err
          console.error(err)
        } else {
          this.$router.replace(this.$route.query.redirect || '/tutorials')
        }
      })
    }
  },
  components: {
    HomeAltLayout
  }
}
</script>

<style lang="postcss">
.error {
  color: red;
}
p {
  margin-left: 10px;
}

.mobileLayout {
  background-image: url('./../../assets/maker.png');
  background-size: cover;
}
.mobileLayout.confirmed {
  background-image: url('./../../assets/droids.png');
  background-size: cover;
}
.forgot-password {
  font-size: 14px!important;
  color: rgba(0, 0, 0, .54);
  line-height: 20px;
  font-weight: 400!important;

}
.forgot-password a {
  display: inline-block;
  color: #27aae1;

}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/LoginAlt.vue